import { useQuery } from '@tanstack/react-query';
import { strapiListPermissionAccessCatalog } from '../../api/strapiPermissionPresets';
import { queryKeys } from '../queryKeys';

export function usePermissionAccessCatalogQuery(jwt: string | null, enabled = true) {
  return useQuery({
    queryKey: queryKeys.permissionAccessCatalog(jwt),
    queryFn: () => strapiListPermissionAccessCatalog(jwt!),
    enabled: Boolean(jwt && enabled),
  });
}
